import { render, staticRenderFns } from "./dashboard-page.vue?vue&type=template&id=139058df&scoped=true&"
import script from "./dashboard-page.vue?vue&type=script&lang=js&"
export * from "./dashboard-page.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-page.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dashboard-page.vue?vue&type=style&index=1&id=139058df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139058df",
  null
  
)

export default component.exports